import React, { Component } from "react";
import axios from "axios";
// import Course from './Course';
import domain from ".././../../../domain";

import { Link } from "react-router-dom";
import { Button } from "mdbreact";
import decode from "jwt-decode";

import { Row, Card, CardBody } from "mdbreact";
import moment from "moment";
// function indexN(cell, row, enumObject, index) {
//   return (<div>{index+1}</div>)
// }
// function dateFormatter(cell) {

//   let s=new Date(cell)

//   return `${('0' + s.getDate()).slice(-2)}/${('0' + (s.getMonth() + 1)).slice(-2)}/${s.getFullYear()}`;
// }
function passwordCheck() {
  let user = window.prompt("Enter your username");

  const { id, username } = decode(localStorage.getItem("token"));
  console.log(id);
  if (username === user) {
    return true;
  } else return false;
}
export default class Courses extends Component {
  constructor() {
    super();
    this.state = {
      courses: [],
    };
  }

  componentDidMount() {
    this.getCourses();
  }
  editButtonFormatter = (row) => {
    // console.log(row)
    return this.state.status === "Completed" ? (
      <Link className="btn blue disabled" to="#">
        EDIT
      </Link>
    ) : (
      <Link className="btn blue " to={`/edit-course/${row}`}>
        EDIT
      </Link>
    );
  };
  deleteButtonFormatter = (row) => {
    return this.state.status === "Completed" ? (
      <Button name="delete" value={row} disabled>
        DELETE
      </Button>
    ) : (
      <Button name="delete" value={row} onClick={this.onDelete.bind(this)}>
        DELETE
      </Button>
    );
  };
  getCourses() {
    axios
      .get(`${domain.DBServer}/fetch-course`)
      .then((response) => {
        // console.log(response.data)
        this.setState({ courses: response.data }, () => {});
      })
      .catch((err) => console.log(err));
  }
  onDelete = (e) => {
    e.preventDefault();
    let r = window.confirm("Do you want to delete the Course details");
    if (r) {
      let k = passwordCheck();
      if (!k) {
        passwordCheck();
      } else {
        // let courseId = this.state.course.course_id;

        axios
          .delete(`${domain.DBServer}/delete-course/${e.target.value}`)
          .then((response) => {
            // console.log(response.data)
            if (response.data === 1) {
              alert("course details deleted Successfully");
              window.location.reload();
            } else {
              alert("Error while deletion");
              window.location.reload();
            }
          })
          .catch((err) => console.log(err));
      }
    } else {
      return false;
    }
  };
  render() {
    let coursetable;
    if (this.state.courses != null) {
      coursetable = this.state.courses.map((course, key) => {
        return (
          <tr key={key}>
            <td>{key + 1}</td>
            <td>{course.course_id}</td>
            <td>{course.title}</td>
            <td>{moment(course.start_date).format("DD/MM/YYYY")}</td>
            <td>{moment(course.end_date).format("DD/MM/YYYY")}</td>
            <td>{course.status}</td>
            <td>
              {" "}
              {course.status === "Completed" ? (
                <Link className="btn blue disabled" to="#">
                  EDIT
                </Link>
              ) : (
                <Link
                  className="btn blue "
                  to={`/edit-course/${course.course_id}`}
                >
                  EDIT
                </Link>
              )}
            </td>
            <td>
              {course.status === "Completed" ? (
                <Button name="delete" value={course.course_id} disabled>
                  DELETE
                </Button>
              ) : (
                <Button
                  name="delete"
                  value={course.course_id}
                  onClick={this.onDelete.bind(this)}
                >
                  DELETE
                </Button>
              )}
            </td>
          </tr>
        );
      });
    }
    //  <TableHeaderColumn  width='50px'  dataFormat={indexN} dataAlign="right" export={false}>S. No</TableHeaderColumn>
    //  <TableHeaderColumn dataField='course_id' dataSort filter={ { type: 'TextFilter' } }>Course Id</TableHeaderColumn>
    //  <TableHeaderColumn dataField='title' dataSort filter={ { type: 'TextFilter' } }>Course Name</TableHeaderColumn>
    //  <TableHeaderColumn dataField='start_date' dataFormat={ dateFormatter } dataSort >Start Date</TableHeaderColumn>
    //  <TableHeaderColumn dataField='end_date' dataFormat={ dateFormatter } dataSort >End Date</TableHeaderColumn>
    //  <TableHeaderColumn dataField='status'  dataSort >status</TableHeaderColumn>
    //  <TableHeaderColumn dataField="course_id" dataFormat={this.editButtonFormatter} export={false}>Edit</TableHeaderColumn>
    //  <TableHeaderColumn dataField="course_id" dataFormat={this.deleteButtonFormatter} export={false}>Delete</TableHeaderColumn>

    return (
      <div>
        <Row className="justify-content-md-center">
          <Card>
            <CardBody>
              <table
                className="table table-striped table-bordered table-responsive-md"
                cellSpacing="0"
                width="100%"
              >
                <thead
                  style={{ textAlign: "center", backgroundColor: "#33b5e5" }}
                >
                  <tr>
                    <th>S. No</th>
                    <th>Course Id</th>
                    <th>Course Title</th>
                    <th>Start Date </th>
                    <th>End Date </th>
                    <th> Status</th>
                    <th> Edit</th>
                    <th> Delete</th>
                  </tr>
                </thead>
                <tbody>{coursetable}</tbody>
              </table>
            </CardBody>
          </Card>
        </Row>
      </div>
    );
  }
}
